import { FONT_FAMILY, MINIMUM_FONT_SIZE } from 'styles/typography'

const themeStyles = colors => {
  const styles = {
    mobileSlider: {
      display: 'flex',
      overflowX: 'scroll',
      width: '100%',
      scrollSnapType: 'x mandatory'
    },
    container: {
      width: '100%',
      marginBottom: 0,
      background: colors.placebo,
      border: 0,
      boxShadow: 'none'
    },
    wellnessTitlesContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: 10
    },
    title: {
      fontFamily: FONT_FAMILY,
      fontWeight: 700,
      fontSize: '18px',
      lineHeight: '20px',
      letterSpacing: 0.23,
      color: colors.approxBlack
    },
    viewAllButton: {
      cursor: 'pointer',
      fontFamily: FONT_FAMILY,
      fontWeight: 500,
      fontSize: MINIMUM_FONT_SIZE,
      lineHeight: '17px',
      color: colors.primary
    },
    carousel: {
      marginTop: 15
    },
    slider: {
      width: '100%'
    },
    slide: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 10px',
      borderRadius: 4,
      flexShrink: 0,
      scrollSnapAlign: 'start',
      scrollSnapStop: 'always',
      width: '65vw',
      minWidth: '220px'
    },
    slideImage: {
      position: 'relative',
      width: '100%',
      height: 'auto',
      minHeight: 280,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      objectFit: 'cover'
    },
    slideInfo: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
      backgroundColor: colors.white
    },
    slideText: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: 18,
      paddingTop: 15,
      padding: '15px 23px 18px'
    },
    slideTitle: {
      fontFamily: FONT_FAMILY,
      fontWeight: 700,
      height: 20,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: 0.23,
      color: colors.approxBlack
    },
    slideDescription: {
      marginTop: 10,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontFamily: FONT_FAMILY,
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '17px',
      color: colors.approxBlack
    },
    slideLink: {
      borderTopWidth: 1,
      borderTopStyle: 'solid',
      borderTopColor: colors.placebo,
      padding: '7.5px 23px 12px',
      cursor: 'pointer',
      fontFamily: FONT_FAMILY,
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '17px',
      color: colors.primary
    },
    linksSliderArea: {
      display: 'flex',
      height: 300
    },
    sliderButton: {
      background: 'none',
      border: 'none',
      fontSize: 24,
      margin: 0,
      padding: 0
    },
    iconAngle: {
      margin: 0
    }
  }
  return styles
}

export default themeStyles
